import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function BetaBanner(props: any) {
  const { setVisible, visible } = props;
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <div className="w-full fixed top-0 inset-x-0 z-[100]">
      <div className="bg-gradient-to-r from-cyan-500/10 to-blue-600/10 backdrop-blur-xl border-b border-cyan-500/20 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-evenly">
          {/* Left */}
          <div className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full bg-cyan-500 animate-pulse shadow-[0_0_6px_rgba(0,200,255,0.8)]"></span>

            <p className="text-sm text-gray-700">
              <span className="font-semibold text-cyan-700">
                Intervify Beta
              </span>{" "}
              — {t("beta.text")} ✨ •{" "}
              <a
                href="https://t.me/Jonibek_2909"
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-700 font-semibold underline underline-offset-2 hover:text-blue-700 transition"
              >
                Telegram: Contact
              </a>
            </p>
          </div>

          <button
            onClick={() => setVisible(false)}
            className="text-gray-500 hover:text-gray-700 transition text-sm"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
